import { Link } from "react-router-dom";
import BrandMark from "@/components/BrandMark";

export default function Footer() {
  return (
    <footer className="bg-forest text-bone/80 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="mb-4">
            <BrandMark variant="dark" size="md" />
          </div>
          <p className="text-sm leading-relaxed text-bone/60 max-w-xs">
            Sense, save, sustain. A motion-driven smart home platform engineered to reduce waste and emissions, one room at a time.
          </p>
        </div>
        <div>
          <p className="label-eyebrow text-bone/60 mb-4">Product</p>
          <ul className="space-y-2 text-sm">
            <li><a href="/#features" className="hover:text-bone">Features</a></li>
            <li><a href="/#how" className="hover:text-bone">How it works</a></li>
            <li><a href="/pricing" className="hover:text-bone">Pricing</a></li>
          </ul>
        </div>
        <div>
          <p className="label-eyebrow text-bone/60 mb-4">Company</p>
          <ul className="space-y-2 text-sm">
            <li><a href="#" className="hover:text-bone">About</a></li>
            <li><a href="#" className="hover:text-bone">Impact</a></li>
            <li><a href="#" className="hover:text-bone">Press</a></li>
          </ul>
        </div>
        <div>
          <p className="label-eyebrow text-bone/60 mb-4">Stay in the loop</p>
          <p className="text-sm text-bone/60">Earth-positive updates. Never spam.</p>
        </div>
      </div>
      <div className="border-t border-bone/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-bone/50">
          <p>© {new Date().getFullYear()} NOA. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/terms" className="hover:text-bone" data-testid="footer-terms">Terms</Link>
            <Link to="/privacy" className="hover:text-bone" data-testid="footer-privacy">Privacy</Link>
            <p className="font-mono">v0.1.0 · carbon-neutral by design</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
